import React from "react";


import './Error404.css';

import ContactCard from '../../../shared/components/ContactCard/ContactCard';

import aboutImg from '../../../utils/assets/notFound/aboutImg.png';
import priceImg from '../../../utils/assets/notFound/priceImg.png';
import contactImg from '../../../utils/assets/notFound/contactImg.png';
import cancelImg from '../../../utils/assets/notFound/cancelImg.png';
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const Error404 = () => {
    

   


    return (

        <section className="Error404__main-container">
            <div className="Error404__error-container">
                <div className="Error404__error-text-container">
                    <div className="Error404__error-title-conainter">
                        <h1>Error 404</h1>
                    </div>
                    <div className="Error404__error-description">
                        <h2>No need to worry.</h2>
                        <p>
                        Get back to your request quickly. Make sure you get the best 
                        pet health care plan for your furry friend.
                        </p>
                    </div>
                </div>
            </div>
            <div className="Error404__pages-container">
                <div className="Error404__pages">
                    <Link  to='/about-us' className="Error404__about-container" style={{backgroundImage: `url(${aboutImg})`}} >
                        <div className="Error404__about-text-container">
                            <h1>About</h1>
                        </div>
                    </Link>

                    <Link to='/price' className="Error404__price-container" style={{backgroundImage: `url(${priceImg})`}}>
                        <div className="Error404__price-text-container">
                            <h1>Price</h1>
                        </div>
                    </Link>

                    <Link to='/contact' className="Error404__contact-container" style={{backgroundImage: `url(${contactImg})`}}>
                        <div className="Error404__contact-text-container">
                            <h1>Contact</h1>
                        </div>
                    </Link>

                    <Link to='/cancel-service' className="Error404__cancel-container" style={{backgroundImage: `url(${cancelImg})`}} >
                        <div className="Error404__cancel-text-container">
                            <h1>Cancel</h1>
                        </div>
                    </Link>


                </div>
            </div>
            <div className="Error404__contact-card-component-container">
               
                    <ContactCard />
               
            </div>
        </section>

    );
}

export default Error404;